module.exports = __webpack_public_path__ + "static/media/UC-516caf22-2255-494b-881e-735eb92e0c3c.728b327f.jpg";